// import Vue from "vue";

import {vm} from "@/main";

const getDefaultState = () => {
	return {
		importProgress: 0,
		showImportProgress: false,
		upgradePlanInterval: null,
		upgradePlanTo: null,
	};
};

const Loader = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
		SET_IMPORT_PROGRESS: (state, payload) => {
			state.importProgress = payload;
		},
		SHOW_PROGRESS_BAR: (state, payload) => {
			state.showImportProgress = payload;
		},
		SET_UPGRADE_PLAN_INTERVAL: (state, payload) => {
			state.upgradePlanInterval = payload;
		},
		UNSET_UPGRADE_PLAN_INTERVAL: state => {
			clearInterval(state.upgradePlanInterval);
			state.upgradePlanInterval = null;
		},
		SET_UPGRADE_PLAN_TO: (state, payload) => {
			state.upgradePlanTo = payload;
		},
	},
	actions: {
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
		setImportProgress: ({ commit }, payload) => {
			commit("SET_IMPORT_PROGRESS", payload);
		},
		showProgressBar: ({ commit, rootState }, payload) => {
			if (payload === false && rootState.Projects.uploadStatus) {
				if (rootState.Projects.uploadStatus == 'processing') {
					commit("SHOW_PROGRESS_BAR", "indeterminate");
				} else {
					commit("SHOW_PROGRESS_BAR", "progress");
				}
			} else if (payload == "indeterminate" && rootState.Projects.uploadStatus) {
				commit("SHOW_PROGRESS_BAR", "progress");
			} else {
				commit("SHOW_PROGRESS_BAR", payload);
			}
		},

	},

	getters: {
	},
};

export default Loader;
